<template>
  <h1 :class="['title', {title__hideMargin: hideMarginLeft}]"><slot></slot></h1>
</template>

<script setup>
defineProps({
  hideMarginLeft: {
    type: Boolean,
    default: false
  }
});
</script>

<style scoped lang="scss">
@use "@/assets/styles/quasar.variables.scss" as *;
.title {
  font-size: 30px;
  line-height: 37px;
  font-weight: 600;
  margin-bottom: 20px;
  margin-top: 0;
  margin-left: 20px;
  color: $title;

  &__hideMargin {
    margin-left: 0;
  }
}
</style>
